import { optionSchema } from "@/common/schemas/option.schema"
import { z } from "zod"

const pictureAttachmentSchema = z.object({
  id: z.string(),
  file: z.custom<{type: string} | string | File>(),
})

const raffleBaseSchema = z.object({
  display_name: z.string().min(3, { message: 'Tamanho minimo: 3 caracteres' }).max(64, { message: 'Tamanho máximo: 64 caracteres' }),
  description: z.string().min(3, { message: 'Tamanho minimo: 3 caracteres' }).max(512, { message: 'Tamanho máximo: 512 caracteres' }),
  available_from: z.string({ message: 'Campo obrigatório' }),
  available_until: z.string({message: 'Campo obrigatório'}),
  max_tickets_per_user: z.string().min(1, { message: 'Campo obrigatório' }),
  select_winner_at: z.string({message: 'Campo obrigatório'}),
  select_winner_time_at: z.string().optional(),
  select_winner_operation_klass: optionSchema,
  creator_establishment_company_branch_id: optionSchema.optional(),
  pictures_attachments_attributes: z
    .array(pictureAttachmentSchema)
    .optional(),
})

export const createSchema = raffleBaseSchema.extend({
  number_of_tickets: optionSchema,
  points_per_ticket: z.string().min(1, { message: 'Campo obrigatório' }),
})

export const updateSchema = raffleBaseSchema

export type TmaisRafflesValidationSchema = z.infer<typeof createSchema>
export type UpdateTmaisRafflesValidationSchema = z.infer<typeof updateSchema>
